var render = function render(){var _vm=this,_c=_vm._self._c;return _c('event-list',{attrs:{"title":_vm.title,"types":_vm.types}})
}
var staticRenderFns = []

export { render, staticRenderFns }